module.exports = __webpack_public_path__ + "static/media/cerrarBlack.476c018c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/cerrarBlack.svg
// module id = 1874
// module chunks = 0